export const LEGAL = {
  privacy: {
    title: "Privacy Policy",
    updated: "Luglio 2026",
    sections: [
      {
        p: [
          "La presente informativa è resa ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 (\u201cGDPR\u201d) e del D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018, a tutti coloro che consultano questo sito e utilizzano il modulo di richiesta prenotazione.",
        ],
      },
      {
        h: "1. Titolare del trattamento",
        p: [
          "Il Titolare del trattamento è Bar Ristorante Gabri, con sede in Via Como 10, 16033 Cavi di Lavagna (GE), P. IVA IT01226470993.",
          "Per qualsiasi richiesta relativa ai tuoi dati puoi contattare il Titolare al numero 328 24 64 286 o all'indirizzo email Archettivaleria07@gmail.com.",
        ],
      },
      {
        h: "2. Tipologie di dati trattati",
        p: [
          "a) Dati forniti volontariamente: quando compili il modulo di prenotazione o ci contatti tramite WhatsApp o telefono, trattiamo nome, numero di telefono, data e orario desiderati, numero di persone ed eventuali note.",
          "b) Dati di navigazione: i sistemi informatici e le procedure software preposte al funzionamento del sito acquisiscono, nel normale esercizio, alcuni dati tecnici (es. indirizzo IP, tipo di browser, orari di accesso) trattati dal fornitore di hosting per garantire sicurezza e corretto funzionamento.",
          "Ti invitiamo a non inserire nel campo note dati particolari (art. 9 GDPR) se non strettamente necessari, ad esempio informazioni su allergie che vorrai comunque comunicare al personale.",
        ],
      },
      {
        h: "3. Finalità e base giuridica",
        p: [
          "I dati sono trattati per: gestire e riscontrare la tua richiesta di prenotazione o di contatto (art. 6.1.b GDPR \u2013 misure precontrattuali; art. 6.1.a \u2013 consenso prestato con l'invio); adempiere a obblighi di legge (art. 6.1.c); garantire la sicurezza e il funzionamento del sito, nostro legittimo interesse (art. 6.1.f).",
        ],
      },
      {
        h: "4. Modalità del trattamento",
        p: [
          "Il trattamento avviene con strumenti informatici e telematici, adottando misure di sicurezza adeguate a prevenire perdita, usi illeciti o non corretti e accessi non autorizzati.",
          "I dati inseriti nel modulo non vengono memorizzati in un database di questo sito: al momento dell'invio sono trasmessi direttamente al ristorante tramite l'applicazione WhatsApp oppure tramite chiamata telefonica.",
        ],
      },
      {
        h: "5. Trasmissione tramite WhatsApp",
        p: [
          "Utilizzando il pulsante di invio verrai reindirizzato all'app WhatsApp, gestita da WhatsApp Ireland Ltd. (gruppo Meta). Il trattamento dei dati tramite WhatsApp è disciplinato dall'informativa privacy di Meta, che potrebbe comportare il trasferimento dei dati al di fuori dello Spazio Economico Europeo sulla base di garanzie adeguate.",
        ],
      },
      {
        h: "6. Cookie e servizi di terze parti",
        p: [
          "La pagina Contatti può integrare la mappa di Google Maps (Google Ireland Ltd.), caricata soltanto previo tuo consenso. Il sito utilizza inoltre i font Google. Per i dettagli consulta la Cookie Policy.",
        ],
      },
      {
        h: "7. Comunicazione e diffusione dei dati",
        p: [
          "I dati non sono diffusi. Possono essere trattati da soggetti autorizzati e da fornitori che agiscono come responsabili del trattamento (es. servizi di hosting), oppure comunicati ad autorità competenti ove previsto dalla legge.",
        ],
      },
      {
        h: "8. Periodo di conservazione",
        p: [
          "I dati relativi alla prenotazione sono conservati per il tempo strettamente necessario a gestire la richiesta e i connessi adempimenti, dopodiché vengono cancellati. I dati di navigazione sono conservati per il periodo tecnicamente necessario.",
        ],
      },
      {
        h: "9. Diritti dell'interessato",
        p: [
          "In qualità di interessato puoi esercitare, nei limiti di legge, i diritti di accesso, rettifica, cancellazione, limitazione, opposizione e portabilità (artt. 15-22 GDPR), nonché revocare in ogni momento il consenso prestato.",
          "Hai inoltre diritto di proporre reclamo all'autorità di controllo: Garante per la protezione dei dati personali (www.garanteprivacy.it).",
          "Per esercitare i tuoi diritti contatta il Titolare ai recapiti indicati al punto 1.",
        ],
      },
      {
        h: "10. Minori",
        p: [
          "Il servizio non è rivolto a minori di 16 anni; l'invio dei dati presuppone la maggiore età o il consenso di chi esercita la responsabilità genitoriale.",
        ],
      },
      {
        h: "11. Modifiche alla presente informativa",
        p: [
          "Il Titolare si riserva di aggiornare la presente informativa. La data di ultimo aggiornamento è indicata in alto: ti invitiamo a consultarla periodicamente.",
        ],
      },
    ],
  },

  cookie: {
    title: "Cookie Policy",
    updated: "Luglio 2026",
    sections: [
      {
        p: [
          "La presente Cookie Policy è redatta in conformità alle Linee Guida del Garante per la protezione dei dati personali (10 giugno 2021) e al GDPR. Descrive i cookie e le tecnologie analoghe utilizzati da questo sito.",
        ],
      },
      {
        h: "1. Cosa sono i cookie",
        p: [
          "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva. Esistono cookie tecnici (necessari) e cookie di profilazione (che richiedono il consenso).",
        ],
      },
      {
        h: "2. Cookie tecnici e di preferenza",
        p: [
          "Il sito utilizza cookie e archiviazione locale strettamente tecnici, necessari al corretto funzionamento delle pagine e a memorizzare la scelta espressa sul banner cookie. Non richiedono il consenso dell'utente ai sensi della normativa vigente.",
        ],
      },
      {
        h: "3. Cookie e contenuti di terze parti",
        p: [
          "Google Maps: la mappa nella pagina Contatti è fornita da Google Ireland Ltd. e può installare cookie tecnici e di profilazione di Google. Per questo motivo la mappa viene caricata solo dopo che hai prestato il consenso; in assenza di consenso è mostrato un segnaposto con la possibilità di attivarla o di aprire Google Maps in una nuova scheda.",
          "Google Analytics 4 (statistica): il sito utilizza Google Analytics, fornito da Google Ireland Ltd., per raccogliere in forma aggregata statistiche anonime sull'utilizzo del sito (es. pagine visitate). Tali cookie/identificatori vengono attivati esclusivamente previo tuo consenso: se scegli \u201cSolo i necessari\u201d, Analytics resta disattivato tramite la modalità Consenso di Google (Consent Mode).",
          "Google Fonts: i caratteri tipografici del sito sono forniti tramite Google Fonts; il caricamento può comportare la comunicazione dell'indirizzo IP a Google.",
        ],
      },
      {
        h: "4. Cookie di profilazione e marketing",
        p: [
          "Il sito non utilizza direttamente cookie di profilazione o di marketing proprietari. Eventuali cookie di profilazione derivano esclusivamente dai servizi di terze parti sopra indicati e sono subordinati al tuo consenso.",
        ],
      },
      {
        h: "5. Gestione del consenso",
        p: [
          "Al primo accesso viene mostrato un banner che consente di \u201cAccettare tutti\u201d i cookie oppure di mantenere \u201cSolo i necessari\u201d. La scelta viene memorizzata e può essere modificata in qualsiasi momento cancellando i dati di navigazione/archiviazione locale del browser: al successivo accesso il banner verrà nuovamente proposto.",
        ],
      },
      {
        h: "6. Come disabilitare i cookie dal browser",
        p: [
          "Puoi gestire o disabilitare i cookie tramite le impostazioni del tuo browser: Google Chrome, Mozilla Firefox, Safari, Microsoft Edge. La disabilitazione dei cookie tecnici potrebbe compromettere alcune funzionalità del sito.",
        ],
      },
      {
        h: "7. Aggiornamenti",
        p: [
          "La presente Cookie Policy può essere aggiornata nel tempo; la data di ultimo aggiornamento è indicata in alto.",
        ],
      },
    ],
  },

  termini: {
    title: "Termini e Condizioni",
    updated: "Luglio 2026",
    sections: [
      {
        p: [
          "L'accesso e l'utilizzo di questo sito implicano l'accettazione dei presenti Termini e Condizioni. Ti invitiamo a leggerli con attenzione.",
        ],
      },
      {
        h: "1. Informazioni generali",
        p: [
          "Il sito è gestito da Bar Ristorante Gabri, Via Como 10, 16033 Cavi di Lavagna (GE), P. IVA IT01226470993, tel. 328 24 64 286, email Archettivaleria07@gmail.com.",
        ],
      },
      {
        h: "2. Oggetto",
        p: [
          "Il sito ha finalità informative e promozionali del ristorante e mette a disposizione uno strumento per inviare una richiesta di prenotazione tramite modulo, WhatsApp o telefono.",
        ],
      },
      {
        h: "3. Prenotazioni",
        p: [
          "La richiesta inviata tramite il modulo, WhatsApp o telefono costituisce una semplice proposta di prenotazione e non una conferma automatica. La prenotazione si intende confermata solo a seguito di espresso riscontro da parte del ristorante.",
          "Al momento le prenotazioni sono accettate esclusivamente per il servizio cena, a partire dalle ore 19:00. Il ristorante si riserva di gestire la disponibilità dei tavoli in base agli orari e alle esigenze del servizio.",
        ],
      },
      {
        h: "4. Modifica e annullamento",
        p: [
          "In caso di rinuncia o modifica della prenotazione ti chiediamo cortesemente di avvisarci telefonicamente con congruo anticipo, così da consentire una migliore gestione dei tavoli.",
        ],
      },
      {
        h: "5. Menu, prezzi e disponibilità",
        p: [
          "I piatti e i prezzi pubblicati sul sito hanno valore indicativo, sono comprensivi di IVA e possono variare in base alla disponibilità e alla stagionalità dei prodotti. Il menu del giorno può differire da quanto pubblicato online. Pane, coperto e servizio sono applicati come indicato nel menu.",
        ],
      },
      {
        h: "6. Allergeni e intolleranze",
        p: [
          "Ai sensi del Regolamento (UE) 1169/2011, le informazioni sulla presenza di sostanze o prodotti che provocano allergie o intolleranze sono disponibili su richiesta rivolgendosi al personale di sala. Ti invitiamo a segnalare eventuali allergie o intolleranze al momento della prenotazione o dell'ordinazione.",
        ],
      },
      {
        h: "7. Proprietà intellettuale",
        p: [
          "Testi, immagini, marchi e loghi presenti sul sito sono di proprietà del gestore o utilizzati con autorizzazione e non possono essere riprodotti, distribuiti o utilizzati senza previo consenso scritto.",
        ],
      },
      {
        h: "8. Strumenti e link di terze parti",
        p: [
          "Il sito utilizza strumenti di terze parti (WhatsApp, Google Maps, Google Fonts) e può contenere collegamenti a siti esterni. Il gestore non è responsabile dei contenuti, delle politiche o del funzionamento di tali servizi e siti terzi.",
        ],
      },
      {
        h: "9. Limitazione di responsabilità",
        p: [
          "I contenuti del sito sono forniti a scopo informativo. Pur adoperandoci per garantirne accuratezza e aggiornamento, non forniamo garanzie in merito alla continuità, disponibilità o assenza di errori del sito e dei servizi di terze parti in esso integrati.",
        ],
      },
      {
        h: "10. Legge applicabile e foro competente",
        p: [
          "I presenti Termini sono regolati dalla legge italiana. Per le controversie con i consumatori è competente il foro del luogo di residenza o domicilio del consumatore, se ubicato in Italia.",
        ],
      },
      {
        h: "11. Risoluzione delle controversie (ODR)",
        p: [
          "Ai sensi del Regolamento (UE) 524/2013, il consumatore può ricorrere alla piattaforma europea di risoluzione delle controversie online (ODR) disponibile all'indirizzo ec.europa.eu/consumers/odr.",
        ],
      },
    ],
  },
};
